import {
  adminAiDownRatingSchema,
  adminAiRatingsSchema,
  type AdminAiRatings,
  type AiRatingSurfaceName,
} from '@steado/admin-contract/ai-ratings';
import { paginationMetaSchema } from '@steado/admin-contract/pagination';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';

import type { ApiClient } from '@/lib/api/client';

export const DOWN_RATINGS_PAGE_SIZE = 10;

export function aiRatingsQueryOptions(api: ApiClient, days: number) {
  return queryOptions({
    queryKey: ['admin', 'ai-ratings', days],
    queryFn: (): Promise<AdminAiRatings> =>
      api.request({ path: '/admin/ai/ratings', query: { days }, schema: adminAiRatingsSchema }),
    placeholderData: (previous) => previous,
  });
}

const downRatingsPageSchema = z.object({
  items: z.array(adminAiDownRatingSchema),
  pagination: paginationMetaSchema,
});
export type DownRatingsPage = z.infer<typeof downRatingsPageSchema>;

export interface DownRatingsSearch {
  readonly days: number;
  readonly surface: AiRatingSurfaceName | undefined;
  readonly cursor: string | undefined;
}

export function aiDownRatingsQueryOptions(api: ApiClient, search: DownRatingsSearch) {
  const query = { ...search, limit: DOWN_RATINGS_PAGE_SIZE };
  return queryOptions({
    queryKey: ['admin', 'ai-ratings-down', query],
    queryFn: async (): Promise<DownRatingsPage> => {
      const response = await api.requestWithMeta({
        path: '/admin/ai/ratings/down',
        query,
        schema: z.array(adminAiDownRatingSchema),
      });
      return downRatingsPageSchema.parse({ items: response.data, pagination: response.meta.pagination });
    },
    placeholderData: (previous) => previous,
  });
}
